"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGenerateReactNearOperationTsConfig = exports.defaultCodegenConfig = exports.generateTypescriptConfig = exports.generateApolloSdkConfig = exports.generateReactApolloConfig = void 0;
const default_codegen_config_1 = __importDefault(require("./default-codegen-config"));
exports.defaultCodegenConfig = default_codegen_config_1.default;
const generate_apollo_sdk_config_1 = __importDefault(require("./generate-apollo-sdk-config"));
exports.generateApolloSdkConfig = generate_apollo_sdk_config_1.default;
const generate_react_apollo_config_1 = __importDefault(require("./generate-react-apollo-config"));
exports.generateReactApolloConfig = generate_react_apollo_config_1.default;
const generate_react_near_operation_typescript_config_1 = __importDefault(require("./generate-react-near-operation-typescript-config"));
exports.getGenerateReactNearOperationTsConfig = generate_react_near_operation_typescript_config_1.default;
const generate_react_typescript_config_1 = __importDefault(require("./generate-react-typescript-config"));
exports.generateTypescriptConfig = generate_react_typescript_config_1.default;
//# sourceMappingURL=index.js.map